import gql from 'graphql-tag';

export const getInspectionInstanceFilterAttributesQuery = gql`
  query GetInspectionInstanceFilterAttributes($channelId: UUID!) {
    inspectionInstanceFilterAttributes(channelId: $channelId) {
      completers {
        completedById
        completedBy {
          _id
          name
        }
      }
      templateNames
    }
  }
`;
